export default __webpack_public_path__ + "static/media/mail.0e170f62.png";